// extracted by mini-css-extract-plugin
module.exports = {"modal-main":"UpdateModal_modal-main__ebmNL","modal-title":"UpdateModal_modal-title__4oKkO","info-img":"UpdateModal_info-img__Flw6y"};